import { render, staticRenderFns } from "./CrudStepperItems.vue?vue&type=template&id=5bb10d8c&"
import script from "./CrudStepperItems.vue?vue&type=script&lang=ts&"
export * from "./CrudStepperItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5bb10d8c', component.options)
    } else {
      api.reload('5bb10d8c', component.options)
    }
    module.hot.accept("./CrudStepperItems.vue?vue&type=template&id=5bb10d8c&", function () {
      api.rerender('5bb10d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Mantenedor/CrudStepperItems.vue"
export default component.exports